import PropTypes from 'prop-types'

import { JSONTree } from 'react-json-tree'
import { TranslationContextProvider } from '../../../components/discover/aivy-pdf-reports/context/general-translations'
import { isSet, NODE_ENV } from '../../../helpers'
import { useDiscover } from '../hooks/useDiscover'
import { EVALUATION_CONTEXT } from '../utils'
import { DISCOVER_TALENT_LOCK } from '../utils/talent-storage-lock'
import LockedTalentSection from './LockedTalentSection'
import TalentMatchSection from './TalentMatchSection'

export default function ConditionalTalentMatchSection({
  className,
  career,
  talent,
  matching,
  matchingProfile,
  isLoading,
  isDatasetComplete,
  resultLock
}) {
  const { isFlexibleMatchingEnabled, selectedResult } = useDiscover()
  const shouldRenderTalentMatch =
    isSet(career) &&
    isSet(talent) &&
    selectedResult === EVALUATION_CONTEXT.MATCHINGPROFILE &&
    !isFlexibleMatchingEnabled

  if (!shouldRenderTalentMatch) return null

  // Gesperrt oder noch nicht gezählt, dann weder Matching noch PDF
  if (
    resultLock === DISCOVER_TALENT_LOCK.LOCKED ||
    resultLock === DISCOVER_TALENT_LOCK.PENDING
  ) {
    return (
      <LockedTalentSection
        className={className}
        pending={resultLock === DISCOVER_TALENT_LOCK.PENDING}
      />
    )
  }

  return (
    <TranslationContextProvider data={matchingProfile}>
      {NODE_ENV === 'develop' && <JSONTree data={matchingProfile} />}
      <TalentMatchSection
        className={className}
        career={career}
        talent={talent}
        matchingProfile={matchingProfile}
        isLoading={isLoading}
        isDatasetComplete={isDatasetComplete}
      />
    </TranslationContextProvider>
  )
}

ConditionalTalentMatchSection.propTypes = {
  className: PropTypes.string,
  career: PropTypes.shape({ id: PropTypes.string.isRequired }),
  talent: PropTypes.shape({ id: PropTypes.string.isRequired }),
  matching: PropTypes.shape({
    complete_dataset: PropTypes.bool
  }),
  matchingProfile: PropTypes.shape({
    id: PropTypes.string.isRequired,
    scores: PropTypes.array
  }),
  isLoading: PropTypes.bool,
  isDatasetComplete: PropTypes.bool,
  resultLock: PropTypes.oneOf(Object.values(DISCOVER_TALENT_LOCK))
}
